import React, { useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { getWaitlist, notifyWaitlist, removeFromWaitlist } from '../../services/api';
import { useConfirm } from '../../components/ConfirmDialog';
import { formatDate, formatDateTime } from '../../utils/formatDateTime';
import { formatPhoneBR } from '../../utils/phone';

export default function TenantWaitlist() {
  const confirm = useConfirm();
  const [items,   setItems]   = useState([]);
  const [total,   setTotal]   = useState(0);
  const [status,  setStatus]  = useState('waiting');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    getWaitlist({ status })
      .then(r => { setItems(r.data.waitlist || []); setTotal(r.data.total || 0); })
      .catch(() => toast.error('Erro ao carregar lista de espera'))
      .finally(() => setLoading(false));
  }, [status]);

  useEffect(() => { load(); }, [load]);

  const onNotify = async id => {
    try { await notifyWaitlist(id); toast.success('Cliente notificado!'); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao notificar'); }
  };

  const onRemove = async id => {
    const ok = await confirm({
      title: 'Remover da lista de espera?',
      message: 'O cliente deixa de ser notificado automaticamente quando abrir um horário. Ele precisará entrar na lista novamente se quiser ser avisado.',
      confirmText: 'Remover',
      variant: 'danger',
    });
    if (!ok) return;
    try { await removeFromWaitlist(id); toast.success('Removido.'); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro'); }
  };

  const fmt = formatDate;
  const fmtDT = formatDateTime;

  return (
    <div className="page-body">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, color: 'var(--gray-900)', fontSize: 22, fontWeight: 700 }}>Lista de Espera</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--gray-500)', fontSize: 13 }}>{total} pessoa{total !== 1 ? 's' : ''} na fila</p>
        </div>
        <select className="input" style={{ width: 'auto' }} value={status} onChange={e => setStatus(e.target.value)}>
          <option value="waiting">Aguardando</option>
          <option value="notified">Notificados</option>
          <option value="booked">Agendados</option>
        </select>
      </div>

      <div className="table-container">
        <table className="table">
          <thead><tr>
            <th>Nome</th><th>Telefone</th><th>Serviço</th><th>Data preferida</th><th>Entrou em</th><th>Notificado em</th><th></th>
          </tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--gray-400)' }}>Nenhum registro encontrado.</td></tr>
            ) : items.map(item => (
              <tr key={item.id}>
                <td data-label="Nome"><strong>{item.client_name}</strong></td>
                <td data-label="Telefone">{formatPhoneBR(item.client_phone)}</td>
                <td data-label="Serviço">{item.service_name || '—'}</td>
                <td data-label="Data preferida">{item.preferred_date ? fmt(item.preferred_date) : 'Qualquer'}</td>
                <td data-label="Entrou em">{fmtDT(item.created_at)}</td>
                <td data-label="Notificado em">{item.notified_at ? fmtDT(item.notified_at) : '—'}</td>
                <td>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {item.status === 'waiting' && (
                      <button className="btn btn-primary" style={{ padding: '4px 10px', fontSize: 12 }} onClick={() => onNotify(item.id)}>
                        Notificar
                      </button>
                    )}
                    <button className="btn btn-danger" style={{ padding: '4px 10px', fontSize: 12 }} onClick={() => onRemove(item.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 24, background: 'var(--blue-50)', border: '1px solid var(--blue-200)', borderRadius: 10, padding: '14px 18px', fontSize: 13, color: 'var(--blue-700)' }}>
        💡 Quando um agendamento é cancelado, o próximo da lista de espera é notificado automaticamente (se horário coincidir).
      </div>
    </div>
  );
}
